import {EditPermissions} from '../../../../../../../shared/models';
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {getEditTypes} from '../../../delegatorUtils';
import {required} from '../../../../../../../shared/utils';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import filter from 'lodash/filter';

export class ChatHubNode {
    action: any = {};

    constructor(nodeType: string) {
        this.action = {
            'actionType': nodeType,
        };
    }

    static toForm(stepData: { [index: string]: any }) {
        return {
            actionParams: this.actionParamsForm(stepData),
            parameters: this.parametersForm(stepData),
            groups: this.groupsForm(stepData)
        };
    }

    static actionParamsForm(stepData: { [index: string]: any }): {} {
        const action = stepData?.action;
        const chatHub = action && action.actionParams && action.actionParams.chathub
            ? action.actionParams.chathub
            : undefined;
        return {
            name: action?.name ? action?.name : '',
            description: action?.description ? action?.description : '',
            imageUrl: chatHub && chatHub.imageUrl ? chatHub.imageUrl : undefined,
            providerId: chatHub && chatHub.providerId ? chatHub.providerId : '',
            instanceId: chatHub && chatHub.instanceId ? chatHub.instanceId : '',
            apiId: chatHub && chatHub.apiId ? chatHub.apiId : '',
            success: action?.result && action?.result.success ? action?.result.success : newStepValue,
            error: action?.result && action?.result.error ? action?.result.error : newStepValue
        };
    }

    static parametersForm(stepData: { [index: string]: any }): {} {
        const action = stepData?.action;
        const paramsList = [];
        const parameters = action && action.actionParams && action.actionParams.chathub && action.actionParams.chathub.parameters
            ? action.actionParams.chathub.parameters
            : undefined;
        if (parameters) {
            for (const key in parameters) {
                paramsList.push({
                    id: key,
                    type: parameters[key].type,
                    value: parameters[key].value,
                });
            }
        }
        return paramsList;
    }

    static groupsForm(stepData: { [index: string]: any }) {
        const action = stepData?.action;
        return action && action.actionParams && action.actionParams.chathub && action.actionParams.chathub.groups
            ? action.actionParams.chathub.groups
            : undefined;
    }

    static getActionTemplate(editPermissions: EditPermissions): UntypedFormGroup {

        const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            name: new UntypedFormControl({value: ''}, [required('Name')]),
            description: new UntypedFormControl({value: ''}, [required('Description')]),
            imageUrl: new UntypedFormControl(''),
            providerId: new UntypedFormControl({value: ''}, [required('Provider ID')]),
            instanceId: new UntypedFormControl({value: ''}, [required('Instance')]),
            apiId: new UntypedFormControl({value: ''}, [required('API ID')]),
            success: new UntypedFormControl(''),
            error: new UntypedFormControl('')
        });
    }

    static getParametersTemplate(): UntypedFormArray {
        return new UntypedFormArray([]);
    }

    static getParameterTemplate(): UntypedFormGroup {
        return new UntypedFormGroup({
            id: new UntypedFormControl(''),
            type: new UntypedFormControl(''),
            value: new UntypedFormControl(''),
            isArray: new UntypedFormControl(false),
            required: new UntypedFormControl(false)
        });
    }

    static getParameterTemplateArrayValue() {
        return new UntypedFormGroup({
            id: new UntypedFormControl(''),
            type: new UntypedFormControl(''),
            value: new UntypedFormControl([]),
            isArray: new UntypedFormControl(false),
            required: new UntypedFormControl(false)
        });
    }

    static getGroupsTemplate(): UntypedFormArray {
        return new UntypedFormArray([]);
    }

    static getGroupTemplate(): UntypedFormGroup {
        return new UntypedFormGroup({
            id: new UntypedFormControl(''),
            name: new UntypedFormControl(''),
            items: new UntypedFormArray([])
        });
    }

    static getGroupItemsTemplate(): UntypedFormArray {
        return new UntypedFormArray([]);
    }

    static getGroupItemTemplate(): UntypedFormGroup {
        return new UntypedFormGroup({
            id: new UntypedFormControl(''),
            parameters: new UntypedFormArray([])
        });
    }

    get nodeData(): {} {
        return {
            action: this.action,
            'type': 'action',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

    addChatHubParams(providerId: string, actionParams: any, paramsList: any, groupsList: any): void {
        const { imageUrl, instanceId, apiId } = actionParams;
        const parameters = {};
        const groups = {};
        paramsList.map(parameter => {
            const { id, type, value, isArray, required } = parameter;
            parameters[id] = {
                type,
                value,
                isArray,
                required
            };
        });

        groupsList.map(group => {
            const { items } = group;
            const groupParameters = [];
            items.map(item => {
                item.parameters.map((parameter) => {
                    groupParameters.push(parameter);
                });
            });

            const parametersIds = Array.from(groupParameters, ({id}) => id);
            const uniqueParametersIds = [...new Set(parametersIds)];

            uniqueParametersIds.map(id => {
                const filtered = filter(groupParameters, {id});
                groups[id] = {};
                 filtered.map((item, index) => {
                     const { type, value, isArray, required } = item;
                     groups[id][index] = {
                         type,
                         value,
                         isArray,
                         required
                    };
                });
            });
        });

        this.action = {
            ...this.action,
            actionParams: {
                chathub: {
                    imageUrl,
                    providerId,
                    instanceId,
                    apiId,
                    parameters,
                    groups
                }
            }
        };
    }

     addActionParams(name: string, description: string): void {
        this.action = {
            ...this.action,
            name,
            description
        };
    }

    addResult(success: string, error: string): void {
        this.action = {
            ...this.action,
            result: {
                success,
                error
            }
        };
    }
}
